<app-center-container
  [title]="title"
  [showClose]="true"
  (close)="closeForm()">

  @if (form) {
    <form>
      <div [formGroup]="step1" [hidden]="currentStep !== 1">
        <app-input-wrapper
          [control]="step1.get('group')"
          label="{{ 'testGroup' | translate }}">
          <mat-select
            class="form_control"
            aria-label="{{ 'testGroup' | translate }}"
            formControlName="group"
            disableOptionCentering
            panelClass="dropdown">
            @for (testGroup of displayedTestGroups; track testGroup.id) {
              <mat-option [value]="testGroup.value">
                {{ testGroup.name }}
              </mat-option>
            }
            @if (displayedCustomBundles?.length) {
              <mat-option [value]="customBundleGroupValue">{{ 'customBundle' | translate | titlecase }}</mat-option>
            }
          </mat-select>
        </app-input-wrapper>
        @if (displayedTestProtocols?.length) {
          <app-input-wrapper
            [control]="step1.get('protocol')"
            label="{{ 'testProtocol' | translate }}">
            <mat-select
              class="form_control"
              aria-label="{{ 'testProtocol' | translate }}"
              formControlName="protocol"
              disableOptionCentering
              panelClass="dropdown">
              @for (testProtocol of displayedTestProtocols; track testProtocol.id) {
                <mat-option [value]="testProtocol.value">
                  {{ testProtocol.name }}
                </mat-option>
              }
            </mat-select>
          </app-input-wrapper>
        }
        @if (isOtherGroup || isOtherProtocol) {
          <app-input-wrapper
            [control]="step1.get('other_protocol')"
            label="{{ 'protocolName' | translate }}"
            identifier="other_protocol">
            <input class="form_control" type="text" formControlName="other_protocol" id="other_protocol">
          </app-input-wrapper>
        }
        <app-input-wrapper
          [control]="step1.get('test_date')"
          label="{{ 'testDate' | translate }}"
          identifier="test_date">
          <input
            class="form_control"
            [matDatepicker]="picker"
            [datePickerFormat]="preferencesService.defaultDateFormat.serverValue"
            [max]="maxTestDate"
            formControlName="test_date"
            id="test_date">
            <mat-datepicker-toggle matSuffix [for]="picker" class="form_datepicker-icon">
            </mat-datepicker-toggle>
          </app-input-wrapper>
          <mat-datepicker #picker></mat-datepicker>
          <button
            class="button button--primary form_button"
            [disabled]="!step1.valid"
            (click)="onNextStep()">
            <span class="bold">{{ lowConfidenceSensitivities?.length ? ('next' | translate) : (isSucceeded ? ('verify' | translate) : ('resolve' | translate)) }}</span>
          </button>
        </div>
        <div [formGroup]="step2" [hidden]="currentStep !== 2" >
          <div formArrayName="sensitivities">
            @for (sensitivityForm of step2.get('sensitivities').controls; track sensitivityForm; let i = $index) {
              <div [formGroupName]="i">
                <div class="row">
                  <div class="col-xs-4">
                    <div class="form_image-box">
                      <img [src]="lowConfidenceSensitivities[i]?.imageSrc" alt="{{ ('sensitivity ' + (i+1)) }}">
                    </div>
                  </div>
                  <div class="col-xs-8">
                    <app-input-wrapper
                      [control]="sensitivityForm.get('sensitivityValue')"
                      label="{{ ('sensitivity ' + (i+1)) }}">
                      <input class="form_control" type="text" formControlName="sensitivityValue">
                    </app-input-wrapper>
                  </div>
                </div>
              </div>
            }
          </div>
          <button
            class="button button--primary form_button"
            [disabled]="!step2.valid"
            (click)="onSubmit()">
            <span class="regular">{{ isSucceeded ? ('verify' | translate) : ('resolve' | translate) }}</span>
          </button>
        </div>
      </form>
    }
  </app-center-container>

  @if (isLoading) {
    <app-loader></app-loader>
  }
